// TimeGranularity.js
import React from 'react';
import { Radio } from 'antd';

const TimeGranularity = ({ value, onChange }) => {
    return (
        <Radio.Group
            value={value}
            onChange={e => onChange(e.target.value)}
            buttonStyle="solid"
            style={{ padding: '4px' }}
        >
            {['day', 'week', 'month'].map(period => (
                <Radio.Button
                    key={period}
                    value={period}
                    style={{
                        padding: '4px 16px',
                        height: '32px',
                        lineHeight: '24px', // This helps center the text vertically
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    {period.charAt(0).toUpperCase() + period.slice(1)}
                </Radio.Button>
            ))}
        </Radio.Group>
    );
};

export default TimeGranularity;
